const initialState = {
  rules: [],
  emailSources: [],
  isLoading: false,
  error: false,
  errorMessage: '',
  preview: [],
  isPreviewLoading: false,
};

// Redux fixes the reducer signature as (state, action), so the default cannot be last.
// eslint-disable-next-line default-param-last
const autoUploadRules = (state = initialState, action) => {
  switch (action.type) {
    case 'BEGIN_GET_AUTO_UPLOAD_RULES':
    case 'BEGIN_CREATE_AUTO_UPLOAD_RULE':
    case 'BEGIN_UPDATE_AUTO_UPLOAD_RULE':
    case 'BEGIN_DELETE_AUTO_UPLOAD_RULE':
    case 'BEGIN_IMPORT_AUTO_UPLOAD_RULES':
    case 'BEGIN_REORDER_AUTO_UPLOAD_RULES':
      return {
        ...state, isLoading: true, error: false, errorMessage: '',
      };

    case 'FINISH_GET_AUTO_UPLOAD_RULES':
      return {
        ...state,
        isLoading: false,
        rules: action.payload.data.auto_upload_rules,
        // Only the index endpoint carries the org's email inboxes.
        emailSources: action.payload.data.email_sources || [],
      };

    case 'FINISH_IMPORT_AUTO_UPLOAD_RULES':
    case 'FINISH_REORDER_AUTO_UPLOAD_RULES':
      return {
        ...state,
        isLoading: false,
        rules: action.payload.data.auto_upload_rules,
      };

    case 'BEGIN_PREVIEW_AUTO_UPLOAD_RULES':
      return {
        ...state, isPreviewLoading: true, error: false, errorMessage: '',
      };

    case 'FINISH_PREVIEW_AUTO_UPLOAD_RULES':
      return {
        ...state,
        isPreviewLoading: false,
        preview: action.payload.data.preview,
      };

    case 'FAILED_PREVIEW_AUTO_UPLOAD_RULES':
      return {
        ...state,
        isPreviewLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Something went wrong',
      };

    case 'FINISH_CREATE_AUTO_UPLOAD_RULE':
      return {
        ...state,
        isLoading: false,
        rules: [...state.rules, action.payload.data.auto_upload_rule],
      };

    case 'FINISH_UPDATE_AUTO_UPLOAD_RULE': {
      const updated = action.payload.data.auto_upload_rule;
      return {
        ...state,
        isLoading: false,
        rules: state.rules.map((rule) => (rule.id === updated.id ? updated : rule)),
      };
    }

    case 'FINISH_DELETE_AUTO_UPLOAD_RULE':
      return { ...state, isLoading: false };

    case 'FAILED_GET_AUTO_UPLOAD_RULES':
    case 'FAILED_CREATE_AUTO_UPLOAD_RULE':
    case 'FAILED_UPDATE_AUTO_UPLOAD_RULE':
    case 'FAILED_DELETE_AUTO_UPLOAD_RULE':
    case 'FAILED_IMPORT_AUTO_UPLOAD_RULES':
    case 'FAILED_REORDER_AUTO_UPLOAD_RULES':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Something went wrong',
      };

    default:
      return state;
  }
};

export default autoUploadRules;
